var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 11.2362C20.9844 12.5615 20.6428 13.8623 20.0057 15.0221C19.3686 16.182 18.4559 17.1648 17.3492 17.8825V18.9682C17.3431 19.5052 17.127 20.018 16.7478 20.3955C16.3686 20.773 15.8568 20.9847 15.3235 20.9846H8.65343C8.1209 20.9805 7.61157 20.7647 7.23645 20.3841C6.86133 20.0034 6.65083 19.489 6.65085 18.9527V17.8825C5.54492 17.1677 4.63245 16.1878 3.99527 15.0305C3.35809 13.8732 3.01611 12.5748 3 11.2517C3 6.69154 7.02826 3 12.0039 3C16.9795 3 21.0001 6.67603 21.0001 11.2362Z",
    stroke: "#FF771D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6982 17.6875V20.999",
    stroke: "#FF771D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1094 17.6875V20.999",
    stroke: "#FF771D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.846 12.6167C13.7607 12.2315 14.0152 11.8684 14.3754 11.7075L16.557 10.7333C17.0161 10.5282 17.5342 10.8642 17.5342 11.3671C17.5346 11.6834 17.471 11.9964 17.3473 12.2871C17.2235 12.5778 17.0422 12.84 16.8144 13.0577C16.5866 13.2755 16.3172 13.4442 16.0224 13.5535C15.7277 13.6629 15.4139 13.7106 15.1003 13.6937C14.4997 13.6438 14.0136 13.3735 13.846 12.6167Z",
    fill: "#FF771D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0435 12.6168C10.1323 12.2321 9.87697 11.8685 9.51635 11.7078L7.32814 10.7325C6.86864 10.5278 6.35059 10.8641 6.35059 11.3671C6.35014 11.6834 6.41374 11.9964 6.53749 12.2871C6.66124 12.5778 6.84255 12.84 7.07034 13.0577C7.29813 13.2755 7.56762 13.4442 7.86234 13.5535C8.15707 13.6629 8.47084 13.7106 8.78449 13.6937C9.36645 13.6438 9.86879 13.3735 10.0435 12.6168Z",
    fill: "#FF771D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreatIcon);
export default __webpack_public_path__ + "static/media/ThreatIcon.bb805a06385b90fd36589dce6ebe2345.svg";
export { ForwardRef as ReactComponent };